import React, { createContext, JSXElementConstructor, useContext, useState } from 'react';
import { RouteObject } from 'react-router/dist/lib/context';
import { Navigation, Route } from '~/models/route';

export const RoutesContext = createContext<
	Partial<{
		routes: Route[];
		routerRoutes: RouteObject[];
		routeStack: Route[];
		currentRouteItem?: Route | null;
		flatRoutes: Route[];
		navigation: Navigation;
		router: React.ReactElement<any, string | JSXElementConstructor<any>> | null;
	}>
>({
	routes: [],
	routerRoutes: [],
	routeStack: [],
	currentRouteItem: null,
	flatRoutes: [],
	navigation: [],
	router: null,
});

export const useRoutes = () => useContext(RoutesContext);

export const SidebarContext = createContext<
	Partial<{
		open: boolean | null;
		minimised: boolean;
		onTemporaryMinimise: () => void;
		onMinimiseToggle: () => void;
		onToggle: () => void;
		mobileOpen: boolean;
		onMobileToggle: () => void;
	}>
>({});

export const useSidebar = () => useContext(SidebarContext);

export const LayoutContext = createContext<{
	hasSidebar: boolean;
	$sidebar: HTMLElement | null;
	setHasSidebar: (p1: boolean) => void;
	contentId: string | null;

	// Header
	$title: HTMLElement | null;
	$search: HTMLElement | null;
	$actions: HTMLElement | null;
	$headerImage: HTMLElement | null;
	hasHeaderImage: boolean;
	setHasHeaderImage: (hasHeaderImage: boolean) => void;
	hasCustomTitle: boolean;
	setHasCustomTitle: (hasTitle: boolean) => void;
	setHasActions: (hasActions: boolean) => void;
	hasActions: boolean;
	$content: React.MutableRefObject<any> | null;
}>({
	hasSidebar: false,
	setHasSidebar: () => null,

	// Header
	$title: null,
	$headerImage: null,
	setHasActions: () => null,
	hasHeaderImage: false,
	setHasHeaderImage: () => null,
	hasActions: false,
	$search: null,
	$actions: null,
	$sidebar: null,
	hasCustomTitle: false,
	setHasCustomTitle: () => null,
	$content: null,
	contentId: null,
});

export const useLayout = () => useContext(LayoutContext);

const ThumbbarContext = createContext<{
	isCreatingCollection: boolean;
	setIsCreatingCollection: (p1: boolean) => void;
	onCreateCollection?: (values: any) => void;
	setSubmitFunc: (func: () => void) => void;
	submitFunc?: () => void;
}>({
	isCreatingCollection: false,
	setIsCreatingCollection: () => null,
	onCreateCollection: () => null,
	setSubmitFunc: () => null,
	submitFunc: () => null,
});

export const useThumbbar = () => useContext(ThumbbarContext);

export const ThumbbarProvider = ({ children }: { children: React.ReactNode }) => {
	const [isCreatingCollection, setIsCreatingCollection] = React.useState(false);

	const [submitFunc, setSubmitFunc] = useState<() => void | null>();

	return (
		<ThumbbarContext.Provider
			value={{ isCreatingCollection, setIsCreatingCollection, setSubmitFunc, submitFunc }}
		>
			{children}
		</ThumbbarContext.Provider>
	);
};
